import React, { useMemo } from "react";
import BaseNode from "./BaseNode";
import { MessageSquareIcon } from "lucide-react";
import { Position } from "@xyflow/react";
import { HandleProps, NodeProps } from "./types";
import FormField from "../FormField";
import { Input } from "../ui/input";

export default function ChatMemoryNode(props: NodeProps) {
  const handles: HandleProps[] = useMemo(
    () => [
      {
        type: "target",
        position: Position.Right,
        id: "output",
      },
    ],
    [],
  );
  return (
    <BaseNode
      title="Chat Memory"
      icon={<MessageSquareIcon size={16} />}
      handles={handles}
      {...props}
    >
      <FormField label="Type">
        <Input name="type" />
      </FormField>
    </BaseNode>
  );
}
